import React from "react";
import SVGInline from "react-svg-inline";
import { GenericModal } from "../../../common/components";
import { warningStyles, cnfButton, CloseIconWrapper } from "./styles";
import { Button, Typography, theme } from "@hiver/hiver-ui-kit";

export const WarningConformationModel = (props) => {
  const { toggleWarningPopOut, confirmAction , title , body , cnfTxt } = props;
  return (
    <GenericModal>
      <div style={warningStyles.modelParent}>
        <div
          style={{
            ...warningStyles.modalCont,
            ...warningStyles.model,
          }}
        >
          {/* Zapier regen warning Pop out header */}
          <div style={warningStyles.header}>
            <SVGInline
              svg={require("./images/warningRed.svg")}
              height={"28px"}
              width={"28px"}
              style={warningStyles.titleCon}
            />
            <span style={warningStyles.title}><Typography variant="h3">{title}</Typography></span>
            <CloseIconWrapper
              style={warningStyles.closeIcon}
              onClick={toggleWarningPopOut}
            >
              <SVGInline
                svg={require("./images/close.svg")}
                height={"24px"}
                width={"24px"}
                style={warningStyles.copy}
              />
            </CloseIconWrapper>
          </div>
          {/* Zapier regen warning Pop out Body*/}
          <div style={warningStyles.popOutBody}><Typography variant="body2" sx={{color: theme.palette.gray.gray3}}>{body}</Typography></div>
          {/* Zapier regen warning Pop out footer */}
          <div style={warningStyles.buttonGroup}>
            <Button 
              onClick={toggleWarningPopOut} 
              sx={cnfButton.cancelStyle}
              color="tertiary"
              size="medium"
              variant="outlined">
              Cancel
            </Button>
            <Button 
              onClick={() => {
                toggleWarningPopOut();
                confirmAction();
              }}
              color="error"
              size="medium"
              variant="contained" 
              sx={cnfButton.cnfTxtStyle}>
              {cnfTxt}
            </Button>
          </div>
        </div>
        <div style={warningStyles.modelOverLay} onClick={toggleWarningPopOut} />
      </div>
    </GenericModal>
  );
};
